import { ReactNode } from "react";
import { EChoiceDisplayValues } from "./EChoiceDisplayValues";
import { useStyle } from "./style";
import { Box, Button, FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { cls } from "itsf-ui-common";
import { EChoiceDisplayMode } from "./EChoiceDisplayMode";

interface IOption {
    label: ReactNode | string;
    value: EChoiceDisplayValues;
    component?: ReactNode;
    disabled?: boolean;
    helper?: ReactNode;
}
interface IParams {
    selectedChoice: EChoiceDisplayValues;
    setSelectedChoice: (choice: EChoiceDisplayValues) => void;
    options: IOption[];
    mode?: EChoiceDisplayMode;
}

export const ChoiceDisplay = (props: IParams) => {
    const { options, selectedChoice, setSelectedChoice, mode = EChoiceDisplayMode.BUTTON } = props;
    const { classes } = useStyle();

    const styleButton = (isSelected: boolean) => cls(classes.button, isSelected ? classes.selected : undefined);

    const orderedOptions = options.sort((optionA, optionB) => parseInt(optionA.value) - parseInt(optionB.value));
    const displayedComponent = orderedOptions.find((option) => option.value === selectedChoice)?.component;

    const renderOptions = () => {
        if (mode === EChoiceDisplayMode.BUTTON) {
            return (
                <div className={classes.buttonsGroup}>
                    {orderedOptions.map((option) => (
                        <Button
                            className={styleButton(option.value === selectedChoice)}
                            color="primary"
                            disabled={option.disabled}
                            key={option.value}
                            variant="outlined"
                            onClick={() => setSelectedChoice(option.value)}
                        >
                            {option.label}
                        </Button>
                    ))}
                </div>
            );
        }

        return (
            <Grid className={classes.radioChoiceDisplayContainer} container justifyContent="center">
                <RadioGroup
                    row
                    value={selectedChoice}
                    onChange={(event) => setSelectedChoice(event.target.value as EChoiceDisplayValues)}
                >
                    {orderedOptions.map((option) => (
                        <Grid className={classes.radioChoiceDisplayOptions} key={option.value}>
                            <FormControlLabel
                                className={classes.radioChoiceDisplayLabel}
                                control={<Radio disabled={option.disabled} />}
                                disabled={option.disabled}
                                label={option.label}
                                labelPlacement="bottom"
                                value={option.value}
                            />
                            {option.helper}
                        </Grid>
                    ))}
                </RadioGroup>
            </Grid>
        );
    };

    return (
        <>
            {renderOptions()}
            {displayedComponent && <Box mt={3}>{displayedComponent}</Box>}
        </>
    );
};
